export default __webpack_public_path__ + "static/media/keto_constipation@3x.64f08ca3.jpg";